import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useSpring, animated } from 'react-spring';
import RightFooter from "../common/RightFooter";
import { imagesTest2, wordsTest2, imagesAndWordsTest2 } from "../../Utils/Constants";
import t from "../../Utils/Translation";
import LykioButton from "../common/LykioButton";
import { useNavigate } from "react-router";
import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import {
    AUTHORIZED_URL_PREFIX,
    AxiosConfig
} from '../../Utils/Constants';
import axios from 'axios'
import { startActivitySession, stopActivitySession, useUpdateActivitySession } from "../../Utils/TimerUtils";

const math = require('mathjs');




const LykioCustomButton = styled(Button)(() => ({
    background: 'linear-gradient(to bottom, #960000, #f1414f)',
    color: "white",
    '&:hover': {
        background: "white",
        color: "#960000",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "#960000"
    },
}));

const Test2 = () => {
    const testId = 't002';
    const [level1Data, setLevel1Data] = useState(null);
    const [level2Data, setLevel2Data] = useState(null);
    const [level3Data, setLevel3Data] = useState(null);
    const [level4Data, setLevel4Data] = useState(null);
    const [level5Data, setLevel5Data] = useState(null);
    const [level6Data, setLevel6Data] = useState(null);
    const [level7Data, setLevel7Data] = useState(null);
    const [biasOld, setBiasOld] = useState(false);
    const [biasYoung, setBiasYoung] = useState(false);
    const [biasFree, setBiasFree] = useState(false);
    const [biasLevel, setBiasLevel] = useState(-1); // 0 = zero , 1 = slight/moderate, 2 = high/intense
    const [nullTest, setNullTest] = useState(false);

    function shuffleArray(array, size) {
        // First, create a copy of the input array
        let result = array.slice();

        // If the array has fewer than <size> elements, repeat some elements
        // until we have exactly <size>
        if (result.length < size) {
            result = doubleArray(result);
        }

        // Then, use the Fisher-Yates shuffle algorithm to shuffle the elements
        for (let i = result.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [result[i], result[j]] = [result[j], result[i]];
        }

        // Finally, return the first <size> elements of the shuffled array
        return result.slice(0, size);
    }

    function doubleArray(array) {
        // First, create a copy of the input array
        let result = array.slice();

        // Then, concatenate the array with itself to create a new array
        // that is twice the size of the original
        result = result.concat(array);

        // Finally, return the new array
        return result;
    }



    function sendDataFromSequence(data, sequence) {
        console.log('This is the data received from the sequence >' + sequence);
        console.log(data);

        if (sequence === 1) {
            //console.log('setting level 1');
            setLevel1Data(data);
        }
        if (sequence === 2) {
            //console.log('setting level 2');
            setLevel2Data(data);
        }
        if (sequence === 3) {
            //console.log('setting level 3');
            setLevel3Data(data);
        }
        if (sequence === 4) {
            //console.log('setting level 4');
            setLevel4Data(data);
        }
        if (sequence === 5) {
            //console.log('setting level 5');
            setLevel5Data(data);
        }
        if (sequence === 6) {
            //console.log('setting level 6');
            setLevel6Data(data);
        }
        if (sequence === 7) {
            //console.log('setting level 7');
            setLevel7Data(data);
            console.log('*** will call handleCalculateAndSaveResults after the level 7 with data');
            console.log(data);
            handleCalculateAndSaveResults(data);
        }
    }

    const [currentChild, setCurrentChild] = useState(1);

    const handleButtonClick = () => {
        console.log('pressing handleButtonClick')
        console.log('currentChild' + currentChild);
        console.log(`setting current child to ${(currentChild + 1) % 17}`);
        setCurrentChild((currentChild + 1) % 17);
    }

    const [isRunning, setIsRunning] = useState(false);

    useUpdateActivitySession(testId, isRunning);

    useEffect(() => {
        console.log('CRURRENT :', currentChild);
        if (currentChild === 2) {
            startActivitySession(testId)
        } else if ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].includes(currentChild)) {
            setIsRunning(true)
        } else {
            setIsRunning(false)
        }
    }, [currentChild])

    let childComponent;

    switch (currentChild) {
        case 1:
            childComponent = <TestWelcome />;
            break;
        case 2:
            childComponent = <IntroToSequence1 />;
            break;
        case 3:
            childComponent = <Sequence1
                images={shuffleArray(imagesTest2, 20)} sequenceIndex={1} leftAttribute1={'ANZIANO'} rightAttribute1={'GIOVANE'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 4:
            childComponent = <IntroToSequence2 />;
            break;
        case 5:
            childComponent = <Sequence2 images={shuffleArray(wordsTest2, 20)} sequenceIndex={2} leftAttribute1={'CATTIVO'} rightAttribute1={'BUONO'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 6:
            childComponent = <IntroToSequence3and4 />;
            break;
        case 7:
            childComponent = <Sequence3 images={shuffleArray(imagesAndWordsTest2, 20)} sequenceIndex={3} leftAttribute1={'ANZIANO'} leftAttribute2={'CATTIVO'} rightAttribute1={'GIOVANE'} rightAttribute2={'BUONO'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 8:
            childComponent = <IntroToSequence3and4 />;
            break;
        case 9:
            childComponent = <Sequence4 images={shuffleArray(imagesAndWordsTest2, 40)} sequenceIndex={4} leftAttribute1={'ANZIANO'} leftAttribute2={'CATTIVO'} rightAttribute1={'GIOVANE'} rightAttribute2={'BUONO'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 10:
            childComponent = <IntroToSequence5 />;
            break;
        case 11:
            childComponent = <Sequence5 images={shuffleArray(imagesTest2, 28)} sequenceIndex={5}
                leftAttribute1={'GIOVANE'}
                rightAttribute1={'ANZIANO'} sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 12:
            childComponent = <IntroToSequence6and7 />;
            break;
        case 13:
            childComponent = <Sequence6 images={shuffleArray(imagesAndWordsTest2, 20)} sequenceIndex={6}
                leftAttribute1={'GIOVANE'} leftAttribute2={'CATTIVO'} rightAttribute1={'ANZIANO'} rightAttribute2={'BUONO'}
                sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 14:
            childComponent = <IntroToSequence6and7 />;
            break;
        case 15:
            childComponent = <Sequence7 images={shuffleArray(imagesAndWordsTest2, 40)} sequenceIndex={7}
                leftAttribute1={'GIOVANE'} leftAttribute2={'CATTIVO'} rightAttribute1={'ANZIANO'} rightAttribute2={'BUONO'}
                sendDataFromSequence={sendDataFromSequence} handleButtonClick={handleButtonClick} />;
            break;
        case 16:
            childComponent = Results(biasFree, biasOld, biasYoung, biasLevel);
            break;
        default:
            childComponent = <div style={{ color: 'black' }}>Error, please refresh</div>;
    }

    const handleCalculateAndSaveResults = async (level7dataFromCaller) => {
        console.log('level7dataFromCaller is>>>')
        console.log(level7dataFromCaller);
        let localBiasOld = false;
        let localBiasYoung = false;
        let localBiasLevel = 0;
        let localBiasFree = false;
        let localNullTry = false;

        console.log('*** Will now log the level4 and level7 results>>> ');
        console.log(level4Data);
        console.log(level7dataFromCaller ? level7dataFromCaller : level7Data);

        let localLevel7Data = level7dataFromCaller ? level7dataFromCaller : level7Data;

        if (level1Data && level2Data && level3Data && level4Data && level5Data && level6Data && localLevel7Data && level4Data.percentage > 75 && localLevel7Data.percentage > 75) {
            // check that the have at least 75% correct
            if (level4Data.timeSpent - localLevel7Data.timeSpent >= 4) {
                // then the user has a gender-related bias in sorting MALE in CAREER and FEMALE in FAMILY
                setBiasOld(true);
                localBiasOld = true;
                // if leve3 average time is <2 zero, if >=2 <4 slight, if > 4 high
                if (level4Data.averageTime < 0.25) {
                    setBiasLevel(0);
                    localBiasLevel = 0;
                }
                else if (level4Data.averageTime < 0.5) {
                    setBiasLevel(1);
                    localBiasLevel = 1;
                } else {
                    setBiasLevel(2);
                    localBiasLevel = 2
                }
            }
            else if (localLevel7Data.timeSpent - level4Data.timeSpent >= 4) {
                // then the user has a gender-related bias in sorting MALE in FAMILY and FEMALE in CAREER
                setBiasYoung(true);
                localBiasYoung = true;
                if (localLevel7Data.averageTime < 0.25) {
                    setBiasLevel(0);
                    localBiasLevel = 0;
                }
                else if (localLevel7Data.averageTime < 0.5) {
                    setBiasLevel(1);
                    localBiasLevel = 1;
                } else {
                    setBiasLevel(2);
                    localBiasLevel = 2;
                }
            }
            else {
                setBiasFree(true);
                localBiasFree = true;
            }

        } else {
            //null
            setNullTest(true);
            localNullTry = true;
        }

        // send data back to server
        const results = {
            id: testId,
            type: "Test",
            localBiasOld,
            localBiasYoung,
            localBiasLevel,
            localBiasFree,
            localNullTry
        }
        //TODO: call the stopActivitySession(testid, success) where success is if complete the activity with positive score
        if (localBiasLevel === 0 && !localNullTry) {
            stopActivitySession(testId, true)
        } else {
            stopActivitySession(testId, false)
        }

        const { data } = await axios.post(
            `${AUTHORIZED_URL_PREFIX}${"/user/saveResults"}`,
            { results: results },
            AxiosConfig()
        )
        if (!data.success) {
            console.log('error sending data to the server');
        }
    }

    const showResults = () => {
        console.log('*** will showResults');
        handleCalculateAndSaveResults();

        handleButtonClick();
        handleCalculateAndSaveResults();
    }


    useEffect(() => {
        function handleParentKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                if (currentChild === 1 && !level1Data) {
                    console.log('1 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 2 && !level1Data) {
                    console.log('2 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 3 && level1Data) {
                    console.log('3 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 4 && !level2Data) {
                    console.log('4 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 6 && !level3Data) {
                    console.log('6 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 8 && !level4Data) {
                    console.log('8 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 10 && !level5Data) {
                    console.log('10 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 12 && !level6Data) {
                    console.log('12 pressing handleButtonClick');
                    handleButtonClick();
                }
                if (currentChild === 14 && !level7Data) {
                    console.log('14 pressing handleButtonClick');
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleParentKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleParentKeyDown);
        };
    }, [currentChild]);

    return <div className="lykioccs-main-content lykiocss-test">
        {childComponent}
        <Row>
            <div className="lykiocss-center">
                {currentChild === 1 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Start')}</LykioCustomButton>}

                {currentChild === 2 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PRIMO PASSO')}</LykioCustomButton>}

                {currentChild === 3 && level1Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

                {currentChild === 4 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PROSSIMO PASSO')}</LykioCustomButton>}

                {currentChild === 5 && level2Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

                {currentChild === 6 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PROSSIMO PASSO')}</LykioCustomButton>}

                {currentChild === 7 && level3Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

                {currentChild === 8 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PROSSIMO PASSO')}</LykioCustomButton>}

                {currentChild === 9 && level4Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

                {currentChild === 10 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PROSSIMO PASSO')}</LykioCustomButton>}

                {currentChild === 11 && level5Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

                {currentChild === 12 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PROSSIMO PASSO')}</LykioCustomButton>}

                {currentChild === 13 && level6Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('Next Step')}</LykioCustomButton>}

                {currentChild === 14 && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={handleButtonClick}>{t('PROSSIMO PASSO')}</LykioCustomButton>}

                {currentChild === 15 && level7Data && <LykioCustomButton style={{ fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }} className="lykiocss-margin-top-2em" onClick={showResults}>{t('Show Results')}</LykioCustomButton>}
            </div>
        </Row>
        <RightFooter />
    </div>
};

export default Test2;


function TestWelcome() {
    return <>
        <div className="lykiocss-margin-top-4em" style={{ display: 'flex', justifyContent: 'center' }}>
            <Container className="lykiocss-margin-top-1em">
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '20em' }} className="lykiocss-center">
                        {t('AGE ASSOCIATION TEST')}
                    </div>
                </Row>

                <Row className="lykiocss-center">
                    <Box
                        style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em' }}
                        color="white"
                        borderRadius={3}
                        p={3}
                        m={2}
                        textAlign={'center'}
                        justifyContent="center"
                        alignItems="center"
                    >

                        <p style={{ fontSize: '21px', textAlign:"left" }}>
                        Questo test - ideato a partire dal Test delle Associazioni Implicite (IAT) sviluppato dai ricercatori di Harvard – ha lo scopo di identificare schemi e tendenze riguardanti l’associazione mentale dell’età a concetti positivi o negativi.
                        </p>
                        <p style={{ fontSize: '21px', textAlign:"left" }}>
                        Il test consente di individuare quel tipo di pregiudizi che, a volte inconsapevolmente, portano a preferire le persone sulla base della loro età, influenzando fortemente le scelte durante il processo di selezione del personale.
                        </p>
                        <p style={{ fontSize: '21px', textAlign:"left" }}>
                        Il test misura la velocità e l'accuratezza delle risposte dei partecipanti e calcola un punteggio che riflette la forza delle loro associazioni implicite. Non si tratta di un test diagnostico, ma piuttosto di uno strumento per aumentare la consapevolezza dei potenziali pregiudizi inconsci ed esplorare modi per affrontarli.
                        </p>
                        <br />

                        <p style={{ fontSize: '21px', textAlign:"left" }}>
                        INIZIO 
                        </p>

                        <p style={{ fontSize: '21px', textAlign:"left", marginLeft:"1em" }}>
                        1. Prima di iniziare il test, posiziona le tue dita sui tasti A e L della tastiera.
                        </p>

                        <p style={{ fontSize: '21px', textAlign:"left", marginLeft:"1em"  }}>
                        2. Durante il test, vedrai una serie di parole e immagini sullo schermo. Segui le istruzioni e rispondi il più rapidamente possibile premendo il tasto A per una categoria e il tasto L per l'altra.
                        </p>

                        <p style={{ fontSize: '21px', textAlign:"left", marginLeft:"1em"  }}>
                        3. Rispondi velocemente e senza pensarci troppo.
                        </p>

                        <br />
                        <p style={{ fontSize: '21px' , textAlign:"left"}}>
                        PER INIZIARE clicca sul tasto spazio o sul pulsante sinistro del mouse.
                        </p>

                        <br />
                    </Box>
                </Row>
            </Container>
        </div>
    </>;
}

function Results(biasFree, biasOld, biasYoung, biasLevel) {

    let text = <div style={{ fontSize: '21px' }}><p>Hai fatto troppi errori in alcune parti del test. Prova a ripeterlo.</p></div>;
    if (biasFree || biasLevel === 0) {
        text = <div style={{ fontSize: '21px' }}>

            <p>Grazie per aver fatto il test e per il tuo interesse nel cercare di identificare eventuali pregiudizi inconsci.</p>
            <p>In base ai tuoi risultati, <span style={{fontWeight:'900'}}>non hai dimostrato di avere alcun pregiudizio implicito significativo relativo a ll’associazione tra età anagrafica e concetti positivi o negativi</span>.</p>
            <p>Questo è un risultato molto positivo, che suggerisce che hai un atteggiamento aperto e privo di pregiudizi verso le persone al di là della loro età.</p>

        </div>
    } else {
        if (biasOld && biasLevel === 1) {
            text = <div style={{ fontSize: '21px' }}>

            <p>Grazie per aver fatto il test e per il tuo interesse nel cercare di identificare eventuali pregiudizi inconsci.</p>
            <p><span style={{fontWeight:'900'}}>I risultati del test suggeriscono una lieve tendenza al pregiudizio nell’associare automaticamente figure anziane con concetti positivi e figure giovani con concetti negativi.</span></p>
            <p>Avere pregiudizi è naturale, e i tuoi risultati non sono in alcun modo correlati alle tue intenzioni, convinzioni o valori morali. I pregiudizi possono essere involontari e derivare da vari fattori, tra cui le esperienze personali, il
            background culturale, le norme sociali e le rappresentazioni dei media.</p>
            <p>La nostra educazione e il contesto culturale nel quale viviamo possono plasmare le nostre convinzioni e attitudini riguardo all’età anagrafica, spesso in modo inconsapevole. Anche se crediamo
            consapevolmente nell’uguaglianza tra soggetti d’età diversa e vogliamo sostenerla, potremmo comunque avere
            alcuni pregiudizi inconsci che influenzano il nostro comportamento e le decisioni che prendiamo.</p>
            <p>Per esempio, chi è cresciuto in un contesto tradizionale nel quale alle persone più anziane viene attribuito un ruolo di competenza e saggezza maggiore,
            potrebbe assumere inconsciamente che un candidato giovane sia necessariamente più sprovveduto e meno competente.</p>
            <p>È importante riconoscere e sfidare questi pregiudizi inconsci in noi stessi e negli altri per promuovere una maggiore uguaglianza e favorire la diversità in
            tutti gli ambiti della vita.</p>

            </div>
        }
        if (biasOld && biasLevel === 2) {
            text = <div style={{ fontSize: '21px' }}>
                
                <p>Grazie per aver fatto il test e per il tuo interesse nel cercare di identificare
                eventuali pregiudizi inconsci.</p>
                <p><span style={{fontWeight:'900'}}>I risultati del test suggeriscono una forte tendenza al pregiudizio nell’associare automaticamente figure
                anziane con concetti positivi e figure giovani con concetti negativi.</span></p>
                <p>Avere pregiudizi è naturale, e i tuoi risultati non sono in alcun modo correlati
                alle tue intenzioni, convinzioni o valori morali. I pregiudizi possono essere
                involontari e derivare da vari fattori, tra cui le esperienze personali, il
                background culturale, le norme sociali e le rappresentazioni dei media.</p>
                <p>La nostra educazione e il contesto culturale nel quale viviamo possono
                plasmare le nostre convinzioni e attitudini riguardo all’età anagrafica, spesso in
                modo inconsapevole. Anche se crediamo consapevolmente nell’uguaglianza tra
                soggetti d’età diversa e vogliamo sostenerla, potremmo comunque avere
                alcuni pregiudizi inconsci che influenzano il nostro comportamento e le
                decisioni che prendiamo.</p>
                <p>Per esempio, chi è cresciuto in un contesto tradizionale nel quale alle persone
                più anziane viene attribuito un ruolo di competenza e saggezza maggiore,
                potrebbe assumere inconsciamente che un candidato giovane sia
                necessariamente più sprovveduto e meno competente.</p>
                <p>È importante riconoscere e sfidare questi pregiudizi inconsci in noi stessi e
                negli altri per promuovere una maggiore uguaglianza e favorire la diversità in
                tutti gli ambiti della vita.</p>

            </div>
        }

        if (biasYoung && biasLevel === 1) {
            text = <div style={{ fontSize: '21px' }}>
                
                <p>Grazie per aver fatto il test e per il tuo interesse nel cercare di identificare
                eventuali pregiudizi inconsci.</p>
                <p><span style={{fontWeight:'900'}}>I risultati del test suggeriscono una lieve tendenza al pregiudizio nell’associare automaticamente figure
                giovani con concetti positivi e figure anziane con concetti negativi.</span></p>
                <p>Avere pregiudizi è naturale, e i tuoi risultati non sono in alcun modo correlati
                alle tue intenzioni, convinzioni o valori morali. I pregiudizi possono essere
                involontari e derivare da vari fattori, tra cui le esperienze personali, il background culturale, le norme sociali e le rappresentazioni dei media.</p>
                <p>La nostra educazione e il contesto culturale nel quale viviamo possono
                plasmare le nostre convinzioni e attitudini riguardo all’età anagrafica, spesso in
                modo inconsapevole. Anche se crediamo consapevolmente nell’uguaglianza tra
                soggetti d’età diversa e vogliamo sostenerla, potremmo comunque avere
                alcuni pregiudizi inconsci che influenzano il nostro comportamento e le
                decisioni che prendiamo.</p>
                <p>Per esempio, chi è cresciuto in un ambiente innovativo e dinamico nel quale
                alle persone più giovani viene riconosciuta la capacità di innovare, potrebbe
                assumere inconsciamente che le persone più anziane siano d’ostacolo al
                cambiamento e all’innovazione.</p> 
                <p>È importante riconoscere e sfidare questi pregiudizi inconsci in noi stessi e
                negli altri per promuovere una maggiore uguaglianza e favorire la diversità in
                tutti gli ambiti della vita.</p>
            </div>
        }

        if (biasYoung && biasLevel === 2) {
            text = <div style={{ fontSize: '21px' }}>

                <p>Grazie per aver fatto il test e per il tuo interesse nel cercare di identificare
                eventuali pregiudizi inconsci.</p>
                <p><span style={{fontWeight:'900'}}>I risultati del test suggeriscono una forte tendenza al pregiudizio
                nell’associare automaticamente figure giovani con concetti positivi e
                figure anziane con concetti negativi.</span></p>
                <p>Avere pregiudizi è naturale, e i tuoi risultati non sono in alcun modo correlati
                alle tue intenzioni, convinzioni o valori morali. I pregiudizi possono essere
                involontari e derivare da vari fattori, tra cui le esperienze personali, il
                background culturale, le norme sociali e le rappresentazioni dei media.</p>
                <p>La nostra educazione e il contesto culturale nel quale viviamo possono plasmare le nostre convinzioni e attitudini riguardo all’età anagrafica, spesso in modo inconsapevole. Anche se crediamo
                consapevolmente nell’uguaglianza tra soggetti d’età diversa e vogliamo sostenerla, potremmo comunque avere
                alcuni pregiudizi inconsci che influenzano il nostro comportamento e le decisioni che prendiamo.</p>
                <p>Per esempio, chi è cresciuto in un ambiente innovativo e dinamico nel quale alle persone più giovani viene riconosciuta la capacità di innovare, potrebbe assumere inconsciamente che le persone più anziane siano d’ostacolo al cambiamento e all’innovazione.</p>
                <p>È importante riconoscere e sfidare questi pregiudizi inconsci in noi stessi e negli altri per promuovere una maggiore uguaglianza e favorire la diversità in tutti gli ambiti della vita.</p>

            </div>
        }

    }



    return <div className="lykiocss-center margin lykiocss-margin-top-4em" style={{ color: 'black' }}>
        <Container>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Box
                    style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em' }}
                    color="white"
                    borderRadius={8}
                    p={3}
                    m={2}
                    textAlign={'center'}
                    justifyContent="center"
                    alignItems="center"
                >
                    <Row>
                        <div className="lykiocss-center">{text}</div>
                    </Row>
                </Box>
            </div>
            <Row>
                <a className="lykiocss-center lykiocss-margin-top-2em" href="/" style={{ textDecoration: 'none' }}>
                    <LykioButton style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", fontSize: '21px', padding: '0.5em', paddingLeft: '2em', paddingRight: '2em' }}>
                        {t("END")}
                    </LykioButton>
                </a>
            </Row>
        </Container>
    </div>;
}

function IntroToSequence1(props) {
    return <>
        <div className="lykiocss-margin-top-4em" style={{ display: 'flex', justifyContent: 'center' }}>
            <Container className="lykiocss-margin-top-1em">
                <Row className="lykiocss-center">
                    <Box
                        style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em', position: 'relative' }}
                        color="white"
                        borderRadius={10}
                        p={3}
                        m={2}
                        textAlign={'center'}
                        justifyContent="center"
                        alignItems="center"
                    >

                        <div style={{ position: 'absolute', left: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    A
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    ANZIANO
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', right: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    L
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    GIOVANE
                                </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ fontSize: '21px', marginTop: '6em' }}>
                            <p>
                            Ti verranno mostrate una serie di immagini.
                            </p>
                            <p>
                            Premi il tasto «A» per associare le immagini che appartengono alla categoria «ANZIANO».
                            Premi il tasto «L» per associare le immagini che appartengono alla categoria «GIOVANE».
                            </p>
                            <p>
                            Se commetti un errore d’associazione, il sistema te lo segnalerà e potrai correggere la risposta.
                            </p>
                        </div>
                    </Box>

                    <div className="lykiocss-center" style={{ margin: '0', fontWeight: '600', fontSize: '18px' }}>
                    Premi spazio o clicca con il tasto sinistro del mouse
                    </div>

                </Row>
            </Container>
        </div>
    </>;
}

function IntroToSequence2(props) {
    return <>
        <div className="lykiocss-margin-top-4em" style={{ display: 'flex', justifyContent: 'center' }}>
            <Container className="lykiocss-margin-top-1em">
                <Row className="lykiocss-center">
                    <Box
                        style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em', position: 'relative' }}
                        color="white"
                        borderRadius={10}
                        p={3}
                        m={2}
                        textAlign={'center'}
                        justifyContent="center"
                        alignItems="center"
                    >

                        <div style={{ position: 'absolute', left: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    A
                                 </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    CATTIVO
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', right: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    L
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    BUONO
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ fontSize: '21px', marginTop: '6em' }}>
                            <p>
                            Ti verranno mostrate una serie di parole.
                            </p>
                            <p>
                            Premi il tasto «A» per associare le parole che appartengono alla categoria «CATTIVO».
                            Premi il tasto «L» per associare le parole che appartengono alla categoria «BUONO».
                            </p>
                            <p>
                            Se commetti un errore d’associazione, il sistema te lo segnalerà e potrai correggere la risposta.
                            </p>
                        </div>
                    </Box>

                    <div className="lykiocss-center" style={{ margin: '0', fontWeight: '600', fontSize: '18px' }}>
                    Premi spazio o clicca con il tasto sinistro del mouse
                    </div>

                </Row>
            </Container>
        </div>
    </>;
}

function IntroToSequence3and4(props) {
    return <>
        <div className="lykiocss-margin-top-4em" style={{ display: 'flex', justifyContent: 'center' }}>
            <Container className="lykiocss-margin-top-1em">
                <Row className="lykiocss-center">
                    <Box
                        style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em', position: 'relative' }}
                        color="white"
                        borderRadius={10}
                        p={3}
                        m={2}
                        textAlign={'center'}
                        justifyContent="center"
                        alignItems="center"
                    >

                        <div style={{ position: 'absolute', left: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    A
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    ANZIANO
                                    </span>
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    o
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    CATTIVO
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', right: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    L
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    GIOVANE
                                </span>
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    o
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    BUONO
                                </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ fontSize: '21px', marginTop: '8em' }}>
                            <p>
                            Ti verranno mostrate una serie di immagini e parole.
                            </p>
                            <p>
                            Premi il tasto «A» per associare gli elementi che appartengono alla categoria «ANZIANO» o «CATTIVO».
                            Premi il tasto «L» per associare gli elementi che appartengono alla categoria «GIOVANE» o «BUONO».
                            </p>
                            <p>
                            Se commetti un errore d’associazione, il sistema te lo segnalerà e potrai correggere la risposta.
                            </p>
                        </div>
                    </Box>

                    <div className="lykiocss-center" style={{ margin: '0', fontWeight: '600', fontSize: '18px' }}>
                    Premi spazio o clicca con il tasto sinistro del mouse
                    </div>

                </Row>
            </Container>
        </div>
    </>;
}

function IntroToSequence5(props) {
    return <>
        <div className="lykiocss-margin-top-4em" style={{ display: 'flex', justifyContent: 'center' }}>
            <Container className="lykiocss-margin-top-1em">
                <Row className="lykiocss-center">
                    <Box
                        style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em', position: 'relative' }}
                        color="white"
                        borderRadius={10}
                        p={3}
                        m={2}
                        textAlign={'center'}
                        justifyContent="center"
                        alignItems="center"
                    >

                        <div style={{ position: 'absolute', left: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    A
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    GIOVANE
                                </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', right: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    L
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    ANZIANO
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ fontSize: '21px', marginTop: '6em' }}>
                            <p>
                            Ti verranno mostrati una serie di immagini.
                            </p>
                            <p>
                            Premi il tasto «A» per associare le immagini che appartengono alla categoria «GIOVANE».
                            Premi il tasto «L» per associare le immagini che appartengono alla categoria «ANZIANO».
                            </p>
                            <p>
                            Se commetti un errore d’associazione, il sistema te lo segnalerà e potrai correggere la risposta.
                            </p>
                        </div>
                    </Box>

                    <div className="lykiocss-center" style={{ margin: '0', fontWeight: '600', fontSize: '18px' }}>
                    Premi spazio o clicca con il tasto sinistro del mouse
    </div>

                </Row>
            </Container>
        </div>
    </>;
}

function IntroToSequence6and7(props) {
    return <>
        <div className="lykiocss-margin-top-4em" style={{ display: 'flex', justifyContent: 'center' }}>
            <Container className="lykiocss-margin-top-1em">
                <Row className="lykiocss-center">
                    <Box
                        style={{ background: 'linear-gradient(to bottom, #960000, #f1414f)', maxWidth: '50em', position: 'relative' }}
                        color="white"
                        borderRadius={10}
                        p={3}
                        m={2}
                        textAlign={'center'}
                        justifyContent="center"
                        alignItems="center"
                    >

                        <div style={{ position: 'absolute', left: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    A
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    GIOVANE
                                </span>
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    o
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    CATTIVO
                                </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', right: '30px', top: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <p style={{ marginBottom: '0em', fontSize: '17px' }}>
                                    Premi
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    L
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    ANZIANO
                                </span>
                                </p>
                                <p style={{ marginBottom: '0.4em', fontWeight: '700', fontSize: '15px' }}>
                                    o
                                </p>
                                <p style={{ marginBottom: '0em' }}>
                                    <span style={{ fontWeight: '900', fontSize: '25px', border: "1px solid white", padding: '0.2em 0.4em 0.2em 0.4em', borderRadius: '0.3em' }}>
                                    BUONO
                                </span>
                                </p>
                            </div>
                        </div>
                        <div style={{ fontSize: '21px', marginTop: '8em' }}>
                            <p>
                            Ti verranno mostrate una serie di immagini e parole.
                            </p>
                            <p>
                            Premi il tasto «A» per associare gli elementi che appartengono alla categoria «GIOVANE» o «CATTIVO».
                            Premi il tasto «L» per associare gli elementi che appartengono alla categoria «ANZIANO» o «BUONO».
                            </p>
                            <p>
                            Se commetti un errore d’associazione, il sistema te lo segnalerà e potrai correggere la risposta.
                            </p>
                        </div>
                    </Box>

                    <div className="lykiocss-center" style={{ margin: '0', fontWeight: '600', fontSize: '18px' }}>
                    Premi spazio o clicca con il tasto sinistro del mouse
                    </div>

                </Row>
            </Container>
        </div>
    </>;
}

function Sequence1(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if(currentImage === 0){
                    console.log(`correct is ${correct}`);
                    handleClose();
                    setCorrect(correct + 1);
                    // console.log(`correct now is ${correct}`);
                    if (currentImage === images.length - 1) {
                        setIsRunning(!isRunning);
                        console.log('stopped the timer...');
                        sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                        handleButtonClick();
                    }
                    setCurrentImage(currentImage + 1);
                }else{
                    if (currentImage < images.length) {
                        if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                            console.log(`correct is ${correct}`);
                            handleClose();
                            setCorrect(correct + 1);
                            // console.log(`correct now is ${correct}`);
                            if (currentImage === images.length - 1) {
                                setIsRunning(!isRunning);
                                console.log('stopped the timer...');
                                sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                                handleButtonClick();
                            }
                            setCurrentImage(currentImage + 1);
                        } else {
                            setIncorrect(incorrect + 1);
                            console.log(`wrong ${incorrect}`);
                            handleShow();
                            if (currentImage === images.length - 1) {
                                // setIsRunning(!isRunning);
                                // console.log('stopped the timer...');
                                // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                                // handleButtonClick();
                            }
                        }
                    } else {
                        setIsRunning(!isRunning);
                        console.log('stopped the timer...');
                        sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                        handleButtonClick();
                    }
                }

            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);

                if (currentImage ===0) {
                    // console.log(`correct is ${correct}`);
                    handleClose();
                    setCorrect(correct + 1);
                    // console.log(`correct now is ${correct}`);
                    if (currentImage === images.length - 1) {
                        setIsRunning(!isRunning);
                        console.log('stopped the timer...');
                        sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                        handleButtonClick();
                    }
                    setCurrentImage(currentImage + 1);
                }else{
                    if (currentImage < images.length) {
                        if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                            // console.log(`correct is ${correct}`);
                            handleClose();
                            setCorrect(correct + 1);
                            // console.log(`correct now is ${correct}`);
                            if (currentImage === images.length - 1) {
                                setIsRunning(!isRunning);
                                console.log('stopped the timer...');
                                sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                                handleButtonClick();
                            }
                            setCurrentImage(currentImage + 1);
                        } else {
                            setIncorrect(incorrect + 1);
                            console.log(`wrong ${incorrect}`);
                            handleShow();
                            if (currentImage === images.length - 1) {
                                // setIsRunning(!isRunning);
                                // console.log('stopped the timer...');
                                // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                                // handleButtonClick();
                            }
                        }
                    } else {
                        setIsRunning(!isRunning);
                        console.log('stopped the timer...');
                        sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                        handleButtonClick();
                    }
                }

            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em', textAlign: 'center' }} className="lykiocss-center">Usa i tasti della tastiera. Premi A per anziano e L per giovane.</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

function Sequence2(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                        console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                        // console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">Usa i tasti della tastiera. Premi A per cattivo e L per buono.</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

function Sequence3(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                        console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                        // console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">Usa i tasti della tastiera. Premi A per anziano o cattivo e L per giovane o buono.</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

function Sequence4(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                        console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                        // console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">Usa i tasti della tastiera. Premi A per anziano o cattivo e L per giovane o buono.</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

function Sequence5(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                        console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                        // console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">Usa i tasti della tastiera. Premi A per giovane e L per anziano.</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

function Sequence6(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                        console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                        // console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">Usa i tasti della tastiera. Premi A per giovane o cattivo e L per anziano o buono.</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

function Sequence7(props) {
    const handleButtonClick = props.handleButtonClick;
    const [show, setShow] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const handleClose = () => {
        console.log("closing modal");
        setShow(false);
        setModalVisible(false);
    };

    const handleShow = () => {
        console.log("showing modal");
        setShow(true);
        setModalVisible(true);
    };

    const sendDataFromSequence = props.sendDataFromSequence;
    const sequenceIndex = props.sequenceIndex;
    const images = props.images;
    const leftAttribute1 = props.leftAttribute1;
    const leftAttribute2 = props.leftAttribute2;
    const rightAttribute1 = props.rightAttribute1;
    const rightAttribute2 = props.rightAttribute2;

    const [keyPressed, setKeyPressed] = useState(null);

    const [currentImage, setCurrentImage] = useState(0);

    const [correct, setCorrect] = useState(0);
    const [incorrect, setIncorrect] = useState(0);

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        console.log('starting the timer...');
        setIsRunning(!isRunning);
    }, []);

    const animation = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: "1500" }
    });

    useEffect(() => {
        console.log('modalVisible ', modalVisible);
        function handleKeyDown(event) {
            if (event.key === " " || event.key === "Spacebar") {
                handleClose();
            }
            if ((event.key === 'L' || event.key === 'l') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log('currentImage ', currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === rightAttribute1 || images[currentImage].attribute === rightAttribute2) {
                        console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
            if ((event.key === 'A' || event.key === 'a') && !modalVisible) {
                setKeyPressed(event.key);
                console.log(event.key);
                console.log(currentImage);
                if (currentImage < images.length) {
                    if (images[currentImage].attribute === leftAttribute1 || images[currentImage].attribute === leftAttribute2) {
                        // console.log(`correct is ${correct}`);
                        handleClose();
                        setCorrect(correct + 1);
                        // console.log(`correct now is ${correct}`);
                        if (currentImage === images.length - 1) {
                            setIsRunning(!isRunning);
                            console.log('stopped the timer...');
                            sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                            handleButtonClick();
                        }
                        setCurrentImage(currentImage + 1);
                    } else {
                        setIncorrect(incorrect + 1);
                        console.log(`wrong ${incorrect}`);
                        handleShow();
                        if (currentImage === images.length - 1) {
                            // setIsRunning(!isRunning);
                            // console.log('stopped the timer...');
                            // sendDataFromSequence({timeSpent: elapsedTime/10, correct: images.length-(incorrect+1), incorrect: incorrect+1, averageTime: math.divide(elapsedTime, math.multiply(images.length,10)), percentage: math.multiply(math.divide(images.length-(incorrect+1),(images.length)),100)}, sequenceIndex);
                            // handleButtonClick();
                        }
                    }
                } else {
                    setIsRunning(!isRunning);
                    console.log('stopped the timer...');
                    sendDataFromSequence({ timeSpent: elapsedTime / 10, correct: images.length - incorrect, incorrect: incorrect, averageTime: math.divide(elapsedTime, math.multiply(images.length, 10)), percentage: math.multiply(math.divide(images.length - incorrect, (images.length)), 100) }, sequenceIndex);
                    handleButtonClick();
                }
            }
        }

        // Add the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImage]);

    // Timer
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setElapsedTime((elapsedTime) => elapsedTime + 1);
            }, 100);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, elapsedTime]);

    return (<div className="lykiocss-center margin lykiocss-margin-top-4em">
        {images && images[currentImage] ?
            <Container>
                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div style={{ textAlign: "center", fontWeight: '500' }}>
                            <div style={{ display: "inline-block", color: 'red', fontWeight: '900', fontSize: '50px' }}>X</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Attenzione!</div>
                            <div style={{ textAlign: "center", fontSize: '18px' }}>Questa associazione non è corretta!</div>
                            <div style={{ textAlign: "center", fontSize: '18px', marginTop: '10px' }}>Premi spazio per continuare</div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                    <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('Usa i tasti della tastiera. Premi A per giovane o cattivo e L per anziano o buono.')}</div>
                </Row>
                <Row className="lykiocss-center" style={{display: "flex", flexWrap: "nowrap"}}>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={leftAttribute2 ? `${leftAttribute1} e ${leftAttribute2}` : leftAttribute1} />
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="lykiocss-center">
                            <animated.div style={animation}>
                                {images[currentImage].url.startsWith('https') ?
                                    <img style={{ width: '28em' }} src={images[currentImage].url} alt="Training image" />
                                    :
                                    <div className="smaller-font" style={{
                                        background: "linear-gradient(to bottom, #960000, #f1414f)",
                                        color: 'white',
                                        padding: '0.6em',
                                        borderRadius: '0.2em',
                                        marginTop: '1em'
                                    }}>{images[currentImage].url}</div>
                                }

                            </animated.div>
                            {/* {currentImage === images.length - 1 &&  <p>Test complete</p>} */}
                        </div>
                    </Col>
                    <Col style={{flex:1}}>
                        <div className="fakeBtnMargin">
                            <FakeButton text={rightAttribute2 ? `${rightAttribute1} e ${rightAttribute2}` : rightAttribute1} />
                        </div>
                    </Col>
                </Row>
            </Container> :
            <Row className="lykiocss-center" style={{ marginBottom: '2em' }}>
                <div style={{ background: "linear-gradient(to bottom, #960000, #f1414f)", color: 'white', padding: '1em', fontSize: '21px', borderRadius: '0.3em', maxWidth: '40em' }} className="lykiocss-center">{t('All done, click on the button to go to the next.')}</div>
            </Row>
        }
    </div>
    );
}

////////////////////

function FakeButton(props) {
    let word1 = props.text;
    let word2 = undefined;
    if (props.text.includes(" e ")) {
        const words = props.text.split(' e ');
        word1 = words[0];
        word2 = words[1];
    }


    return (
        word2 ? <div>
            <div
                style={{
                    background: "linear-gradient(to bottom, #960000, #f1414f)",
                    color: 'white',
                    padding: '10px 10px',
                    textAlign: 'center',
                    borderRadius: '0.5em',
                    maxWidth: '15em',
                    fontSize: '24px',
                    fontWeight: '900',
                    cursor: 'pointer',
                }}
            >
                <div>
                    <p style={{ margin: '1px', fontWeight: '900' }}>{word1}</p>
                    <p style={{ margin: '1px', fontWeight: '900' }}>o</p>
                    <p style={{ margin: '1px', fontWeight: '900' }}>{word2}</p>
                </div>
            </div>
        </div> :
            <div
                style={{
                    background: "linear-gradient(to bottom, #960000, #f1414f)",
                    color: 'white',
                    padding: '10px 10px',
                    textAlign: 'center',
                    borderRadius: '0.5em',
                    maxWidth: '15em',
                    fontSize: '24px',
                    fontWeight: '900',
                    cursor: 'pointer',
                }}
            >
                {word1}
            </div>
    );
}